<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="Goods No" prop="id">
                <a-input v-model="queryParam.id" @pressEnter="handleQuery" :maxLength="20" placeholder="Please enter goods no" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="Goods Name" prop="goodsName">
                <a-input v-model="queryParam.goodsName" @pressEnter="handleQuery" placeholder="Please enter goods name" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />Query</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />Reset</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['goods:goods:add']">
          <a-icon type="plus" />
          Add Gift
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['goods:goods:remove']">
          <a-icon type="delete" />
          Delete
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :scroll="{ x: '130%', y: tableScrollY }"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        @change="handleSortChange"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.picture" :src="record.picture" style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none" />
          </div>
        </template>
        <span slot="categoryId" slot-scope="text, record">
          {{ getCategoryNameById(record.categoryId) }}
        </span>
        <span slot="stock" slot-scope="text, record">
          {{ record.stock }}
        </span>
        <template slot="goodsType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.GoodsTypeEnum" :value="record.goodsType" />
        </template>
        <span slot="status" slot-scope="text, record">
          <custom-dict-tag :options="customDict.GoodsOnOffEnum" :value="record.status" />
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleUpdate(record, undefined)" v-hasPermi="['goods:goods:edit']">
             <a-icon type="edit" />Edit
          </a>
          <a-divider type="vertical" v-hasPermi="['goods:goods:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['goods:goods:remove']">
            <a-icon type="delete" />Delete
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
      <img alt="example" style="width: 100%" :src="previewUrl" />
    </a-modal>
    <!-- 选择商品弹窗 -->
    <select-goods-modal
      :visible="selectGoodsVisible"
      @cancel="selectGoodsVisible = false"
      @confirm="handleSelectGoodsConfirm"
    />
  </page-header-wrapper>
</template>

<script>
import { pageGoods, delGoods, batchSetGift } from '@/api/goods/goods'
import { listCategory } from '@/api/goods/category'
import CustomDictTag from '@/components/DictCustomTag'
import SelectGoodsModal from './modules/SelectGoodsModal'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Gift',
  components: {
    CustomDictTag,
    SelectGoodsModal
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      categoryList: [{ id: '0', categoryName: '' }],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 选择商品弹窗
      selectGoodsVisible: false,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        goodsName: undefined,
        isGift: 1,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'Goods No',
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          width: 160,
          fixed: 'left'
        },
        {
          title: 'Goods Name',
          dataIndex: 'goodsName',
          width: 300,
          fixed: 'left'
        },
        {
          title: 'Goods Image',
          dataIndex: 'picture',
          width: '80px',
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: 'Category',
          dataIndex: 'categoryId',
          width: '120px',
          scopedSlots: { customRender: 'categoryId' }
        },
        {
          title: 'Goods Type',
          dataIndex: 'goodsType',
          width: '120px',
          scopedSlots: { customRender: 'goodsType' },
          align: 'center'
        },
        {
          title: 'Status',
          dataIndex: 'status',
          width: '100px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: 'Price',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'price',
          width: '100px'
        },
        {
          title: 'Stock',
          dataIndex: 'stock',
          scopedSlots: { customRender: 'stock' },
          width: '80px'
        },
        {
          title: 'Create Time',
          dataIndex: 'createTime',
          width: 150,
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: 'Operation',
          dataIndex: 'operation',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getCategoryList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    getTotal(total) {
      return 'Total ' + total + ' items'
    },

    /** 查询赠品列表 */
    getList() {
      this.loading = true
      pageGoods(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /*页面初始化时获取分类类别*/
    getCategoryList() {
      listCategory().then(response => {
        this.categoryList = response.data
      })
    },

    getCategoryNameById(id) {
      if (!id) {
        return ''
      }
      let cateInfo = this.categoryList.find(e => e.id === id)
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return ''
      }
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        goodsName: undefined,
        isGift: 1,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      if (sorter.order) {
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },

    /** 新增赠品按钮操作 */
    handleAdd() {
      this.selectGoodsVisible = true
    },

    /** 选择商品确认 */
    handleSelectGoodsConfirm(selectedItems) {
      const ids = selectedItems.map(item => item.id)
      this.$confirm({
        title: 'Confirm Set as Gift',
        content: 'Set the selected ' + selectedItems.length + ' item(s) as gifts?',
        onOk: () => {
          return batchSetGift({ idList: ids, isGift: 1 }).then(() => {
            this.$message.success('Set successfully')
            this.selectGoodsVisible = false
            this.getList()
          })
        },
        onCancel: () => {
          this.selectGoodsVisible = false
        }
      })
    },

    /** 编辑赠品信息 **/
    handleUpdate(row) {
      this.$router.push({
        path: 'goodsForm',
        query:
          {
            id: row.id
          }
      })
    },

    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: 'Confirm to delete the selected data',
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delGoods(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                'Deleted successfully',
                3
              )
            })
        },
        onCancel() {
          that.ids = []
        }
      })
    }
  }
}
</script>